<template>
  <SfComment
    :id="comment.id"
    :allow-attachment-deletion="
      !!comment.allowedActions.edit && !disableInteraction
    "
    :attachment-ids="comment.attachmentIds"
    :attachments="comment.attachments"
    :author-name="comment.authorName"
    :commentable-id="commentableId"
    commentable-type="Remark"
    :company-id="companyId"
    :ledger-id="ledgerId"
    :created-at="comment.createdAt"
    :editing="comment.editing"
    :edited-at="comment.editedAt"
    :read="comment.read"
    :rendered-text="comment.renderedText"
    :text="comment.text"
    :pulse-mention-warning="comment.pulseMentionWarning"
    :period-name="periodName"
    :period-private="periodPrivate"
    :unread-top-offset="unreadTopOffset"
    :unread-bottom-offset="unreadBottomOffset"
    :border="border"
    @delete-attachment="
      (attachmentId) => emit('deleteAttachment', attachmentId)
    "
  >
    <template #actions>
      <RemarkActions
        :allowed-actions="comment.allowedActions"
        @click="(action) => emit('action', action)"
      />
    </template>
  </SfComment>
</template>

<script setup lang="ts">
import RemarkActions from '@app/shared/vue/components/molecules/remark/remark-actions.vue'
import SfComment from '@app/shared/vue/components/molecules/remark/sf-comment.vue'
import type {
  RemarkActions as RemarkAction,
  RemarkComment,
} from '@app/shared/vue/components/molecules/remark/types'

interface Props {
  comment: RemarkComment
  commentableId: number
  companyId: number
  ledgerId: number
  disableInteraction?: boolean
  periodName?: string
  periodPrivate?: boolean
  unreadTopOffset?: boolean
  unreadBottomOffset?: boolean
  border?: boolean
}

defineProps<Props>()

const emit =
  defineEmits<{
    deleteAttachment: [number]
    action: [RemarkAction]
  }>()
</script>
